import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import AccountsData from "../../components/AccountMetrics/AccountsData";
import CloseTrades from "../../components/AccountMetrics/CloseTrades";
import Goals from "../../components/AccountMetrics/Goals";
import Statistics from "../../components/AccountMetrics/Statistics";
import TradeReports from "../../components/AccountMetrics/TradeReports";
import TradingGrowth from "../../components/AccountMetrics/TradingGrowth";
import customStyles from "../../customStyles";
import LoaderOverlay from "../../reusableComponents/LoaderOverlay/Index";
import RePaymentModal from "../../reusableComponents/RePaymentModal/RePaymentModal";
import Share from "../../assets/icons/share.svg";
import { resetRebillPayments } from "../../utils/apis/userApi";
import {
  formatDateInTimeZone,
  FormatUSD,
  isAccountResetEligible,
} from "../../utils/helpers/string";
import {
  accountMetrics,
  setLastPayment,
} from "../../utils/store/reducers/accountMetricsSlice";
import { setDefaultLoginId } from "../../utils/store/reducers/accountSlice";
import { returnErrors } from "../../utils/store/reducers/Error";
import "./style.scss";
import CalendarOne from "../../components/AccountMetrics/Calender/CalendarOne";
import axios from "axios";
import {
  accountLoginIdsListReq,
  updateAccountMetrics,
  postTradovateMarketDataSubscription,
} from "../../utils/apis/accountsApi";
import moment from "moment";
import { Button, message, Modal, Drawer } from "antd";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  XIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { LinkOutlined, StopOutlined, SyncOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import TradeHistory from "../../components/Analysis/TradeHistory/TradeHistory";

// Trading platform configuration
const TRADING_PLATFORMS = {
  "projectx/quantower": {
    name: "ProjectX/Quantower",
    url: null,
    label: "Launch ProjectX/Quantower",
  },
  "tradovate prop": {
    name: "Tradovate/Ninja",
    url: "https://trader.tradovate.com/welcome",
    label: "Launch Tradovate/Ninja",
  },
  "alpha trader": {
    name: "Alpha Trader",
    url: "https://futures.alphatrader.com/",
    label: "Launch AlphaTrader",
  },
  quantower: {
    name: "Quantower",
    url: "https://www.quantower.com/download",
    label: "Launch Quantower",
  },
  volumetrica: {
    name: "DeepChart",
    url: "https://volumetrica.alpha-futures.com/",
    label: "Launch DeepChart",
  },
  deepchart: {
    name: "DeepChart",
    url: "https://volumetrica.alpha-futures.com/",
    label: "Launch DeepChart",
  },
  wealthcharts: {
    name: "WealthCharts",
    url: "https://app.wealthcharts.com/",
    label: "Launch WealthCharts",
  },
  tradingview: {
    name: "TradingView",
    url: "https://tv-demo.t4login.com/tradingview/oauth2/authorize?response_type=code&client_id=TProd-PProd-Demo&redirect_uri=https%3A%2F%2Fwww.tradingview.com%2Ftrading%2Foauth-redirect%2Fplus500us%2F&state=eyJ2ZXJzaW9uIjoiMiIsInJlcV9pZCI6IjAuODM2MzYxOTYiLCJ0cmFkaW5nX3Nlc3Npb25faWQiOiI1NWRhZGY4My1mMTI3LTQ0MTctYTM2MC05NWY3OWFmMDcyMTUiLCJjb25uZWN0aW9uX3R5cGUiOiJwcm9kLWRlbW8iLCJyZWRpcmVjdF90b19vcmlnaW4iOnRydWUsInVzZV9tb2JpbGVfYXBwX3JlZGlyZWN0IjpudWxsfQ",
    label: "Launch TradingView",
  },
  default: {
    name: "N/A",
    url: null,
    label: "N/A",
  },
};

function AccountMetrics() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { login_id } = useSelector((state) => state?.accountList);
  const { data, isLoading, error } = useSelector(
    (state) => state?.accountMetrics,
  );
  const { results } = useSelector((state) => state?.accountList?.data);
  const dispatch = useDispatch();
  const { idToken } = useSelector((state) => state?.auth);
  useEffect(() => {
    login_id !== null &&
      dispatch(accountMetrics({ id: login_id, idToken: idToken }));
    dispatch(setDefaultLoginId(login_id));
  }, [dispatch]);

  const handleChange = (selectedOption) => {
    Number(selectedOption.value) !== login_id &&
      dispatch(setDefaultLoginId(selectedOption.value));
    dispatch(accountMetrics({ id: selectedOption.value, idToken: idToken }));
  };
  const [accountLoginIdsList, setAccountLoginIdsList] = useState([]);
  const options = accountLoginIdsList;
  useEffect(() => {
    const fetchAccountLoginIds = async () => {
      try {
        const response = await accountLoginIdsListReq(idToken); // Replace with the correct function to fetch data
        setAccountLoginIdsList(response);
        if (!login_id) {
          dispatch(setDefaultLoginId(response[0].value));
          dispatch(accountMetrics({ id: response[0].value, idToken: idToken }));
        }
      } catch (error) {
        console.error("Error fetching account login IDs:", error);
      }
    };

    fetchAccountLoginIds();
  }, [idToken]);

  const statusMapping = {
    0: "Active",
    1: "Locked for day",
    2: "Violation",
    3: "Inactive",
    4: "Closed",
    5: "GoalAchieved",
    6: "Ineligible",
  };
  const colorClassMapping = {
    0: "status-active",
    1: "status-temporary-violation",
    2: "status-violation",
    3: "status-inactive",
    4: "status-closed",
    5: "status-goal-achieved",
    6: "status-ineligible",
  };
  const statusCode = data?.account_metrics?.get_trading_accounts?.status;
  const colorClass = colorClassMapping[statusCode] || "status-unknown";

  const statusText = statusMapping[statusCode] || "Unknown status";

  const [selectedDateValue, setSelectedDateValue] = useState();
  const [payloadPurpose, setPayloadPurpose] = useState(null);

  const activeAccount = accountLoginIdsList?.find((item) => {
    return Number(item.value) === Number(login_id);
  });

  const activeAccountFromList = results?.find(
    (item) => Number(item.login_id) === Number(activeAccount?.value),
  );

  const [open, setOpen] = useState(false);
  const resetAccount = () => {
    setOpen(true);
  };
  const [isLoadings, setIsLoadings] = useState(false);
  const [payload, setPayload] = useState({
    payment_method: "nuvei",
    payment_type: payloadPurpose === "rebill" ? "rebill" : "reset",
    account_id: data?.login_id,
    promo: null,
  });



  const handleGetFreeMarketData = async () => {
    try {
      setIsLoadings(true);
      const res = await postTradovateMarketDataSubscription(idToken);
      message.success(res.detail || "Successfully added Tradovate Subscription");
    } catch (error) {
      dispatch(
        returnErrors(
          error.response?.data?.detail || "Failed to get free market data",
          error.response?.status || 400
        )
      );
    } finally {
      setIsLoadings(false);
    }
  };

  const handleSubmit = async () => {
    setIsLoadings(true);

    try {
      const response = await resetRebillPayments(idToken, payload);

      if (response.status < 399) {
        dispatch(setLastPayment(response?.data?.data));
        window.location.replace(response?.data.url);
      } else {
        dispatch(returnErrors(response.data.detail, 400));
      }
    } catch (error) {
      dispatch(returnErrors(error.message, error.response?.status || 500));
    } finally {
      setIsLoadings(false);
      setOpen(false);
    }
  };
  useEffect(() => {
    error && dispatch(returnErrors(error, 400));
  }, [error]);

  const [showMore, setShowMore] = useState(false);

  // const { login_id } = useSelector((state) => state.accountList);

  const [newMaxLoss, setNewMaxLoss] = useState([]);

  useEffect(() => {
    const getNewMaxLoss = async () => {
      try {
        let config = {
          headers: { Authorization: `Bearer ${idToken}` },
        };
        const response = await axios.get(
          `account/account-meta-data/${login_id}/`,
          config,
        );
        setNewMaxLoss(response.data);
      } catch (error) {
        console.error("Error fetching max loss:", error);
      }
    };

    login_id && getNewMaxLoss(); // Call the async function
  }, [login_id]);

  // reset logic

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const [openRepay, setOpenRepay] = useState(false);

  const handleRenewAccount = async () => {
    setIsLoadings(true);
    try {
      const response = await resetRebillPayments(idToken, payload);

      if (response.status < 399) {
        dispatch(setLastPayment(response?.data?.data));
        window.location.replace(response?.data.url);
      } else {
        dispatch(returnErrors(response.data.detail, 400));
      }
    } catch (error) {
      dispatch(returnErrors(error.message, error.response?.status || 500));
    } finally {
      setIsLoadings(false);
      setOpenRepay(false);
    }
  };
  const handleRebillClick = async (e) => {
    e.preventDefault();

    try {
      setIsLoadings(true);

      const response = await resetRebillPayments(idToken, payload);

      if (response.status < 399) {
        dispatch(setLastPayment(response?.data?.data));
        window.location.replace(response.data.url);
      } else {
        dispatch(returnErrors(response.data.detail, 400));
      }
    } catch (error) {
      console.error("An error occurred during the rebill process:", error);
      dispatch(returnErrors("An unexpected error occurred", 500));
    } finally {
      setIsLoadings(false);
      setOpenRepay(false);
    }
  };

  const payoutDate = moment(data?.expiry_date).format("DD-MM-YYYY");
  const today = moment().format("DD-MM-YYYY");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = (certificate) => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const infoBoxData = [
    {
      title: "Start Date",
      value: moment(data?.start_date).format("DD-MM-YYYY"),
    },
    ...(activeAccount?.phase === "evaluation"
      ? [
        {
          title: "Rebill Date",
          value: moment(data?.expiry_date).format("DD-MM-YYYY"),
        },
      ]
      : []),
    {
      title: "Balance",
      value: FormatUSD(data?.account_balance_equity?.balance),
    },
    // { title: "Equity", value: FormatUSD(data?.account_balance_equity?.equity) },
    {
      title: "Starting Balance",
      value: FormatUSD(
        data?.account_metrics?.calculated_data?.starting_balance,
      ),
    },
    // { title: "Status", value: "$6000" },
  ];

  // Get trading platform configuration
  const tradingPlatform =
    TRADING_PLATFORMS[data?.trading_platform_name?.toLowerCase()] ||
    TRADING_PLATFORMS.default;

  console.log(TRADING_PLATFORMS, "tradingplt123");
  console.log(tradingPlatform, "tradingplt");

  return (
    <div className="account-stats">
      {isLoading && <LoaderOverlay />}
      <RePaymentModal
        open={open}
        setOpen={setOpen}
        handleSubmit={
          payloadPurpose === "rebill" ? handleRebillClick : handleRenewAccount
        }
        isLoading={isLoadings}
        setPayload={setPayload}
        payload={payload}
        initialAmount={data?.account_metrics?.reset_price}
        size={""}
        id={data.login_id}
        items={data}
        activeTab={data?.trading_platform === 1 ? 0 : 1}
        today={payoutDate === today}
      />
      {/* <ResetModal
        open={open}
        setOpen={setOpen}
        isLoading={isLoadings}
        msg="Are you sure you want to reset this account? This action cannot be
            undone."
        handleSubmit={() => {
          setOpen(false);
          setOpenRepay(true);
        }}
        data={data}
      /> */}
      <RePaymentModal
        open={openRepay}
        setOpen={setOpenRepay}
        handleSubmit={handleSubmit}
        isLoading={isLoadings}
        setPayload={setPayload}
        payload={payload}
        size={""}
        initialAmount={data?.account_metrics?.reset_price}
        id={data?.login_id}
      />

      <div className="account-stats-header">
        <div className="account-stats-header-Item">
          <p>Account</p>
          <Select
            value={options.find((item) => item.value === login_id)}
            onChange={handleChange}
            options={options}
            isSearchable={false}
            styles={customStyles}
            className="react_select_container"
            classNamePrefix="react-select"
          />
          {statusCode !== undefined && (
            <div className={`status-btn ${colorClass}`}>{statusText}</div>
          )}
        </div>
        <div className="account-stats-header-Item metrics">
          <Link to="/trading-history" href="Ttradi" className="metrics-button">
            {" "}
            Trade History
          </Link>
          <a href="account-analysis" className="metrics-button">
            Analysis
          </a>
          {data?.trading_platform_name?.toLowerCase() === "tradovate prop" && (
            <div
              className="metrics-button"
              onClick={!isLoadings ? handleGetFreeMarketData : undefined}
            >
              Add Tradovate Subscription
            </div>
          )}
          {data?.trading_platform_name?.toLowerCase() === "alpha trader" && (
            <div
              className="metrics-button"
              onClick={!isLoadings ? handleGetFreeMarketData : undefined}
            >
              Add Market Data Subscription
            </div>
          )}
          {isAccountResetEligible(activeAccountFromList) && (
            <div
              className="metrics-button"
              onClick={() => resetAccount(data?.login_id)}
            >
              Reset
            </div>
          )}

          {/* Only show Launch button if platform is not ProjectX/Quantower */}
          {data?.trading_platform_name?.toLowerCase() !== "projectx/quantower" && (
            <>
              {data?.trading_platform_name?.toLowerCase() === "tradingview" && (
                <a
                  href={TRADING_PLATFORMS["alpha trader"].url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="metrics-button"
                  aria-label="Launch Alpha Trader trading platform"
                >
                  {TRADING_PLATFORMS["alpha trader"].label}
                </a>
              )}
              <a
                href={tradingPlatform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="metrics-button"
                aria-label={`Launch ${tradingPlatform.name} trading platform`}
              >
                {tradingPlatform.label}
              </a>
            </>
          )}
          <p className="metrics-button" onClick={handleOpenModal}>
            Share <img width={30} height={30} src={Share} alt="" />
          </p>
          <ShareCertificateModal
            data={data}
            isModalOpen={isModalOpen}
            handleClose={handleCloseModal}
          />
        </div>
      </div>

      <div className="account-stats-info">
        {infoBoxData.map((data, index) => (
          <TgInfoBox key={index} title={data.title} value={data.value} />
        ))}
      </div>

      <TradingGrowth
        data={data}
        activeAccount={activeAccount}
        newMaxLoss={newMaxLoss}
      />
      <div className="marge_container">
        <AccountsData data={data} />
        {/* <Goals data={data} newMaxLoss={newMaxLoss} /> */}
      </div>

      {/* <div className="show_more_container">
        <span className="line_one">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="431"
            height="2"
            viewBox="0 0 431 2"
            fill="none"
          >
            <path d="M0 1H431" stroke="#414344" />
          </svg>
        </span>
        <button
          onClick={() => {
            setShowMore((pre) => !pre);
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: "smooth",
            });
          }}
        >
          Show {showMore ? "less" : "more"} Advanced Stats
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.5222 9.05127C17.7861 9.31514 17.7861 9.74296 17.5222 10.0068L11.5 16.0291L5.47778 10.0068C5.21391 9.74296 5.21391 9.31514 5.47778 9.05127C5.74165 8.7874 6.16947 8.7874 6.43334 9.05127L11.5 14.1179L16.5667 9.05127C16.8305 8.7874 17.2583 8.7874 17.5222 9.05127Z"
              fill="white"
            />
          </svg>
        </button>
        <span className="line_one">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="431"
            height="2"
            viewBox="0 0 431 2"
            fill="none"
          >
            <path d="M0 1H431" stroke="#414344" />
          </svg>
        </span>
      </div>

      {showMore && <TradeHistory />} */}

      {/* <Statistics data={data} /> */}

      {/* <CloseTrades data={data} /> */}
      {/* <div
        className="main_calendar_container"
        style={{
          display: "grid",
          gap: "20px",
          gridTemplateColumns: selectedDateValue && "65% 33%",
        }}
      >
        <CalenderContainer
          data={data}
          setSelectedDateValue={setSelectedDateValue}
        />
        <CalendarOne data={data} setSelectedDateValue={setSelectedDateValue} />
        {selectedDateValue &&
          (data.trading_platform === 1 ? (
            <div className="selected_trade_con">
              <h4>
                <span>
                  {selectedDateValue[0]?.createdAt
                    ? formatDateInTimeZone(
                        selectedDateValue[0]?.createdAt,
                        "DD-MM-YYYY (dddd)"
                      )
                    : "No transaction on this date"}
                </span>
              </h4>
              {selectedDateValue?.map((trade) => (
                <div
                  className={
                    trade?.pnl > 0
                      ? "profit_con trade_container"
                      : trade?.pnl < 0
                      ? "loss_con trade_container"
                      : "trade_container"
                  }
                >
                  <p>
                    <span>{trade?.symbolId}</span>{" "}
                    <span
                      className={
                        trade?.pnl > 0
                          ? "positive_value"
                          : trade?.pnl < 0
                          ? "negative_value"
                          : ""
                      }
                    >
                      {FormatUSD(trade?.pnl)} P&L
                    </span>
                  </p>
                  <p>
                    {formatDateInTimeZone(
                      trade.createdAt,
                      "DD-MM-YYYY hh:mm:ss A"
                    )}
                  </p>
                  <span>{"Trade Duration : " + trade?.tradeDuration}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="selected_trade_con">
              <h4>
                <span>
                  {selectedDateValue[0]?.date
                    ? formatDateInTimeZone(
                        selectedDateValue[0]?.date,
                        "DD-MM-YYYY (dddd)"
                      )
                    : "No transaction on this date"}
                </span>
              </h4>
              {selectedDateValue?.map((trade) => (
                <div
                  className={
                    trade?.pnl > 0
                      ? "profit_con trade_container"
                      : trade?.pnl < 0
                      ? "loss_con trade_container"
                      : "trade_container"
                  }
                >
                  <p>
                    <span>{trade?.symbol || "No Symbol"}</span>{" "}
                    <span
                      className={
                        trade?.pnl > 0
                          ? "positive_value"
                          : trade?.pnl < 0
                          ? "negative_value"
                          : ""
                      }
                    >
                      {FormatUSD(trade?.pnl)} P&L
                    </span>
                  </p>
                  <p>
                    Open Time:{" "}
                    {formatDateInTimeZone(
                      trade.open_time,
                      "DD-MM-YYYY hh:mm:ss A"
                    )}
                  </p>
                  <p>
                    Close Time:{" "}
                    {formatDateInTimeZone(
                      trade.close_time,
                      "DD-MM-YYYY hh:mm:ss A"
                    )}
                  </p>
                  <span>{"Trade Duration : " + trade?.trade_duration}</span>
                  <span>
                    {"Action : " +
                      trade?.in_action +
                      " -> " +
                      trade?.out_action}
                  </span>
                </div>
              ))}
            </div>
          ))}
      </div> */}

      {/* {showMore === true && <TradeReports />} */}
    </div>
  );
}

export default AccountMetrics;

const TgInfoBox = ({ title, value }) => {
  return (
    <div className="tginfobox">
      <p>{title}</p>
      <span className={value < 0 ? "negative-profit" : "positive-profit"}>
        {value}
      </span>
    </div>
  );
};

const ShareCertificateModal = ({ data, isModalOpen, handleClose }) => {
  const [copied, setCopied] = useState(false);
  const [isPublic, setIsPublic] = useState(data?.is_public || false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const certificateUrl = `${window.location.origin}/public-account-stats/${data?.login_id}`;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    data && setIsPublic(data?.is_public);
  }, [data]);

  const handleCopy = () => {
    navigator.clipboard.writeText(certificateUrl);
    setCopied(true);
    message.success("Link copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleCertificate = async () => {
    try {
      setLoading(true);
      const response = await updateAccountMetrics(data?.login_id, {
        is_public: !isPublic,
        public_permissions: isPublic ? [1] : [],
      });
      setIsPublic(response?.is_public || !isPublic);
      message.success(
        response?.is_public ? "Link generated successfully!" : "Link disabled.",
      );
    } catch (error) {
      message.error("Failed to update link status.");
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <>
      {isPublic ? (
        <>
          <p>Link generated. Copy and share it!</p>
          <p>You can disable the link anytime.</p>
          <Button
            type="primary"
            danger
            icon={<StopOutlined />}
            loading={loading}
            onClick={toggleCertificate}
          >
            Disable Link
          </Button>
        </>
      ) : (
        <div className="generate-link-container">
          <p>Link not generated. Please generate a link to share.</p>
          <Button
            type="primary"
            icon={<SyncOutlined />}
            loading={loading}
            onClick={toggleCertificate}
          >
            Generate Link
          </Button>
        </div>
      )}

      {isPublic && (
        <>
          <div className="share-options">
            <FacebookShareButton url={certificateUrl}>
              <FacebookIcon size={50} round />
            </FacebookShareButton>
            <TwitterShareButton url={certificateUrl}>
              <XIcon size={50} round />
            </TwitterShareButton>
            <WhatsappShareButton url={certificateUrl}>
              <WhatsappIcon size={50} round />
            </WhatsappShareButton>
            <TelegramShareButton url={certificateUrl}>
              <TelegramIcon size={50} round />
            </TelegramShareButton>
            <EmailShareButton url={certificateUrl}>
              <EmailIcon size={50} round />
            </EmailShareButton>
          </div>

          <div className="share-link-container">
            <input
              type="text"
              value={certificateUrl}
              readOnly
              className="share-link"
            />
            <button onClick={handleCopy} className="copy-btn">
              {copied ? (
                "Copied!"
              ) : (
                <>
                  <LinkOutlined /> Copy Link
                </>
              )}
            </button>
          </div>
        </>
      )}
    </>
  );

  return isMobile ? (
    <Drawer
      title="Share"
      placement="bottom"
      onClose={handleClose}
      open={isModalOpen}
      className="share-certificates-modal"
    >
      {content}
    </Drawer>
  ) : (
    <Modal
      title="Share"
      open={isModalOpen}
      onCancel={handleClose}
      footer={null}
      className="share-certificates-modal"
    >
      {content}
    </Modal>
  );
};
